import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    ClientOption,
    CreateClientOptionInput,
    DeleteClientOptionInput,
    UpdateClientOptionInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ClientOptionService {
    private amplifyClient = generateClient();

    constructor() {}

    async getClientOption(id: string): Promise<ClientOption> {
        try {
            if (id) {
                const data = (
                    await this.amplifyClient.graphql({
                        query: queries.getClientOption,
                        variables: {
                            id
                        }
                    })
                ).data.getClientOption;
                if (data) {
                    return data as ClientOption;
                } else {
                    const item = await this.createClientOption({ id });
                    return item;
                }
            } else {
                return null;
            }
        } catch (error) {
            console.error('Error finding ClientOptions:', error);
            return null;
        }
    }

    async listClientOptions(): Promise<ClientOption[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listClientOptions
                })
            ).data.listClientOptions.items;
            if (data) return data as ClientOption[];
        } catch (error) {
            console.error('Error finding ClientOptions:', error);
            return null;
        }
    }

    async createClientOption(
        input: CreateClientOptionInput
    ): Promise<ClientOption> {
        try {
            const clientOption = (
                await this.amplifyClient.graphql({
                    query: mutations.createClientOption,
                    variables: {
                        input
                    }
                })
            ).data.createClientOption;
            if (clientOption) return clientOption as ClientOption;
        } catch (error) {
            console.error('Error creating ClientOption:', error);
            return null;
        }
    }

    async updateClientOption(
        input: UpdateClientOptionInput
    ): Promise<ClientOption> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.updateClientOption,
                    variables: {
                        input
                    }
                })
            ).data.updateClientOption;
            if (client) return client as ClientOption;
        } catch (error) {
            console.error('Error updating ClientOption:', error);
            return null;
        }
    }

    async deleteClient(input: DeleteClientOptionInput): Promise<ClientOption> {
        try {
            const deleteClient = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteClientOption,
                    variables: {
                        input
                    }
                })
            ).data.deleteClientOption;
            return deleteClient as ClientOption;
        } catch {
            console.error('Error deleted ClientOption:', Error);
            return null;
        }
    }
}
